<template>
  <div class="usercenter">
    <div class="usercenter__header">
      <el-menu
        :default-active="this.index.toString()"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#051922"
        text-color="#fff"
        active-text-color="#ffd04b">
        <el-menu-item index="0">个人中心</el-menu-item>
        <el-menu-item index="1">我的授权</el-menu-item>
        <el-menu-item  v-if="!this.validateUserNull()" index="2">我的产品</el-menu-item>
        <el-menu-item index="3">授权说明</el-menu-item>
        <el-menu-item index="4">答疑说明</el-menu-item>
        <el-menu-item index="99">联系我们</el-menu-item>
      </el-menu>
    </div>
    <div class="usercover">
      <h1>我的授权</h1>
    </div>
    <div class="usercontent">
      <h2><a href="#" class="header-anchor">#</a> 核心授权</h2>
      <el-table
        :data="mainList"
        v-loading="loading1"
        border
        style="width: 100%"
        empty-text="看来您是铁杆用户，订单久远找不到啦，请联系官方补全信息：bladejava@qq.com">
        <el-table-column
          prop="orderid"
          label="订单号"
          width="200">
        </el-table-column>
        <el-table-column
          prop="name"
          label="授权名"
          width="150">
        </el-table-column>
        <el-table-column
          prop="qq"
          label="授权QQ"
          width="120">
        </el-table-column>
        <el-table-column
          prop="datetime"
          label="订单日期"
          width="160">
        </el-table-column>
        <el-table-column
          prop="auth"
          label="授权资料">
        </el-table-column>
      </el-table>
      <h2><a href="#" class="header-anchor">#</a> 插件授权</h2>
      <el-table
        :data="pluginList"
        v-loading="loading2"
        border
        style="width: 100%"
        empty-text="还没有插件授权哦，推荐前往市场挑选：https://bladex.cn/#/market">
        <el-table-column
          prop="orderid"
          label="订单号"
          width="200">
        </el-table-column>
        <el-table-column
          prop="name"
          label="授权名"
          width="150">
        </el-table-column>
        <el-table-column
          prop="qq"
          label="授权QQ"
          width="120">
        </el-table-column>
        <el-table-column
          prop="datetime"
          label="订单日期"
          width="160">
        </el-table-column>
        <el-table-column
          prop="auth"
          label="授权资料">
        </el-table-column>
      </el-table>
    </div>
    <login ref="login" @submit="init"></login>
  </div>
</template>

<script>
import nav from '@/const/userlist'
import {mapState} from "vuex";
import marketlist from "@/const/marketlist";
import Record from '@/util/record';

export default {
  name: "temp",
  data() {
    return {
      name: "",
      index: 0,
      nav: nav,
      navObj: {},
      box: false,
      loading1: false,
      loading2: false,
      mainList: [],
      pluginList: []
    };
  },
  computed: {
    activeNav() {
      return this.$route.path.replace("/user", "");
    },
    ...mapState(['user']),
  },
  watch: {
    $route(n, o) {
      if (this.validatenull(this.user)) {
        return false;
      }
      if (n === o) return;
      this.findItem(this.nav, this.$route.path.replace("/user", ""));
    }
  },
  created() {
    if (this.validatenull(this.user)) {
      return false;
    }
    this.init();
    this.initTable();
  },
  mounted() {
    if (this.validatenull(this.user)) {
      this.$message.error({message: '请先购买BladeX授权后登录官网～', offset: 60})
      this.$refs.login.handleOpen()
      return false;
    }
  },
  methods: {
    init() {
      this.findItem(this.nav, this.$route.path.replace("/user", ""));
      const path = this.$route.path.replace("/user/", "");
      if (path === 'center') {
        this.index = 0;
      } else if (path === "auth") {
        this.index = 1;
      } else if (path === "product") {
        this.index = 2;
      } else if (path === "intro") {
        this.index = 3;
      } else if (path === "qa") {
        this.index = 4;
      } else {
        this.index = 99;
      }
    },
    initTable() {
      this.loading1 = true;
      let queryOrder = new Record('x_order');
      queryOrder.select("orderid,name,qq,datetime");
      queryOrder.equalTo("qq", "=", `'${this.user}'`);
      queryOrder.equalTo("flag", "=", true);
      queryOrder.find().then(res => {
        if (!this.validatenull(res.data[0])) {
          this.mainList = res.data;
          this.mainList[0].auth = "相关源码资料请见官方发送的商业授权邮件";
          this.mainList[0].datetime = new Date(this.mainList[0].datetime).Format("yyyy-MM-dd hh:mm:ss");
        }
        if (!this.validatenull(res.data[1])) {
          this.mainList = res.data;
          this.mainList[1].auth = "相关源码资料请见官方发送的商业授权邮件";
          this.mainList[1].datetime = new Date(this.mainList[1].datetime).Format("yyyy-MM-dd hh:mm:ss");
        }
        if (!this.validatenull(res.data[2])) {
          this.mainList = res.data;
          this.mainList[2].auth = "相关源码资料请见官方发送的商业授权邮件";
          this.mainList[2].datetime = new Date(this.mainList[1].datetime).Format("yyyy-MM-dd hh:mm:ss");
        }
        if (!this.validatenull(res.data[3])) {
          this.mainList = res.data;
          this.mainList[3].auth = "相关源码资料请见官方发送的商业授权邮件";
          this.mainList[3].datetime = new Date(this.mainList[1].datetime).Format("yyyy-MM-dd hh:mm:ss");
        }
        if (!this.validatenull(res.data[4])) {
          this.mainList = res.data;
          this.mainList[4].auth = "相关源码资料请见官方发送的商业授权邮件";
          this.mainList[4].datetime = new Date(this.mainList[1].datetime).Format("yyyy-MM-dd hh:mm:ss");
        }
        if (!this.validatenull(res.data[5])) {
          this.mainList = res.data;
          this.mainList[5].auth = "相关源码资料请见官方发送的商业授权邮件";
          this.mainList[5].datetime = new Date(this.mainList[1].datetime).Format("yyyy-MM-dd hh:mm:ss");
        }
        this.loading1 = false;
      });

      this.loading2 = true;
      let queryMarket = new Record("x_market");
      queryMarket.select("orderid,name,qq,datetime,org");
      queryMarket.equalTo("username", "=", `'${this.user}'`);
      queryMarket.equalTo("flag", "=", true);
      queryMarket.limit(50);
      queryMarket.find().then(res => {
        if (!this.validatenull(res.data[0])) {
          this.pluginList = res.data;
          for (let i = 0; i < res.data.length; i++) {
            let org = res.data[i].org;
            let name = "管理员QQ";
            if (org.indexOf("@") > 0) {
              name = "管理员邮箱";
            }
            this.pluginList[i].auth = `相关源码资料请联系${name} [${org}] 获取`;
            this.pluginList[i].datetime = new Date(this.pluginList[i].datetime).Format("yyyy-MM-dd hh:mm:ss");
          }
        }
        this.loading2 = false;
      });
    },
    handleSelect(key) {
      if (this.validatenull(this.user)) {
        return false;
      }
      this.index = Number(key);
      if (this.index === 0) {
        this.$router.push('/user/center');
      } else if (this.index === 1) {
        this.$router.push('/user/auth');
      } else if (this.index === 2) {
        this.$router.push('/user/product');
      } else if (this.index === 3) {
        this.$router.push('/user/intro');
      } else if (this.index === 4) {
        this.$router.push('/user/qa');
      } else if (this.index === 99) {
        this.$router.push('/user/contact');
      }
    },
    findItem(nav, value) {
      nav.forEach(ele => {
        if (ele.groups) {
          this.findItem(ele.groups[0].list, value);
        } else if (ele.path === value) {
          this.navObj = ele;
          this.name = ele.name;
        }
      });
    },
    validateUserNull() {
      if (this.validatenull(this.user)) {
        return true;
      }
      if (this.user === 'bladex') {
        return false;
      }
      const org = marketlist.filter(item => item.org === this.user)
      return this.validatenull(org);
    },
  }
};
</script>
<style>

.usercover {
  padding: 2rem 0;
  text-align: center;
  color: #fff;
  background: url(/images/bk.svg) repeat center center scroll
}

.usercover h1 {
  font-size: 28px;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}

.usercover h2 {
  font-size: 26px;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}
</style>
<style lang="scss">
.silder {
  width: 280px;
  height: calc(100% - 80px);
  position: fixed;
  top: 0;
  bottom: 0;
  margin-top: 100px;
  overflow: auto;
  background-color: #fff;
  border-right: 1px solid #e8e8e8;

  .item {
    transition: all 0.9s cubic-bezier(0.215, 0.61, 0.355, 1);

    &--bold {
      > a {
        font-weight: 700;
      }
    }

    &--active {
      background-color: #f0f5ff;
      border-right: 3px solid #3e63f9;

      a {
        color: #3e63f9;
      }
    }

    a {
      display: block;
      color: #314659;
    }

    .title {
      font-size: 14px;
      line-height: 40px;
      height: 40px;
      list-style-type: disc;
      list-style-position: inside;
      cursor: pointer;
    }
  }
}

.goods {
  padding-top: 100px;
  margin-bottom: 50px;
  box-sizing: border-box;
  display: flex;
}

.usercontent {
  padding: 0 330px 30px 330px !important;
  color: #314659;
  min-height: 600px;
  font-size: 14px;
  line-height: 2;
  width: 100%;
  box-sizing: border-box;

  h2 {
    font-size: 24px;
    line-height: 32px;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #0d1a26;
    font-family: Lato, Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif;
    margin: 1.6em 0 .6em;
    font-weight: 500;
    clear: both;
  }
}
</style>


<style lang="scss">
.usercenter {
  padding-top: 60px;
  min-height: 500px;
  height: auto;

  &__header {
    width: 100%;
  }

  &__title {
    width: 100%;
    font-size: 38px;
    text-align: center;
    font-weight: 600;
    padding-top: 20px;
  }

  &__search {
    width: 600px;
    margin: 25px auto 0 auto;
  }

  &__content {
    width: 100%;
    margin: 30px 0;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    justify-content: center;
  }

  &__text {
    box-sizing: border-box;
    margin: 15px 10px 0 10px;
    width: 20%;
    cursor: pointer;

    p {
      margin-top: 1rem;
      margin-bottom: 0;
      line-height: 30px;
    }
  }
}
</style>
